export const palette = (mode) => ({
  mode,
  primary: {
    main: "#094F99",
    light: "#0F84FF",
    dark: "#05284D",
  },
  secondary: {
    main: "#B7DAFF",
    light: "#E7F3FF",
    dark: "#6FB5FF",
  },
  background: {
    default: mode === "light" ? "#f5f5f5" : "#121212",
    paper: mode === "light" ? "#ffffff" : "#1e1e1e",
  },
});
